<div id="<%= modal_window_id %>" class="modal" tabindex="-1" role="dialog">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title"><%= title %></h5>
			</div>
			<div class="modal-body">
				<p><%- message %></p>
			</div>
			<div class="modal-footer">
				<button id="anvil-modal-confirm-ok-btn" type="button" class="btn btn-primary" data-bs-dismiss="modal"><%- btn_ok %></button>
			</div>
		</div>
	</div>
</div>
